import { ComponentProps } from 'react';

import Tooltip, { TooltipTriggerProps } from '@components/Tooltip';

type Props = Pick<ComponentProps<typeof Tooltip>, 'content' | 'initialDirection'> & {
  children: (tooltipTriggerProps?: TooltipTriggerProps) => React.ReactNode;
  condition: boolean;
};

const ConditionalTooltip = ({ children, condition, ...tooltipProps }: Props) => {
  if (!condition) {
    return children();
  }

  return <Tooltip {...tooltipProps}>{tooltipTriggerProps => children(tooltipTriggerProps)}</Tooltip>;
};

export default ConditionalTooltip;
